import React from 'react'
import { Link } from 'react-router-dom'

const ANWENDUNGEN_URL = 'https://anwendungen.online'

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-white/10 bg-studio-bg/80 backdrop-blur-xl">
      <div className="mx-auto max-w-6xl px-4 py-6 sm:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-white/70" aria-label="Footer-Navigation">
            <Link to="/dashboard/anleitung" className="hover:text-white transition">Anleitung</Link>
            <Link to="/dashboard/impressum" className="hover:text-white transition">Impressum</Link>
            <Link to="/dashboard/datenschutz" className="hover:text-white transition">Datenschutz</Link>
            <Link to="/dashboard/agb" className="hover:text-white transition">AGB</Link>
            <Link to="/dashboard/nutzungsbedingungen" className="hover:text-white transition">Nutzungsbedingungen</Link>
            <Link to="/dashboard/faq" className="hover:text-white transition">FAQ</Link>
            <a href={ANWENDUNGEN_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
              anwendungen.online
            </a>
          </nav>
          <p className="text-xs text-white/50">
            © Marc Fischer Digital Solution NRW · AI Mastering Studio
          </p>
        </div>
      </div>
    </footer>
  )
}
